<template>
  <div class="variant_asset_raw" v-if="content_asset">
    <AssetPresenter :content_asset="content_asset" :variant="variant" />
  </div>
</template>

<script lang="ts">
import axios from '@lib/apiClient'
import AssetPresenter from '@survey/components/AssetPresenter.vue'

export default {
  components: { AssetPresenter },
  props: ['variant_id'],
  data() {
    return {
      variant: null,
      content_asset: null,
    }
  },
  beforeMount() {
    axios
      .get(`/api/variants/${this.variant_id}.json`)
      .then((response) => {
        this.variant = response.data.variant
        this.content_asset = response.data.content_asset
        if (this.content_asset.text == null)
          this.content_asset.text = response.data.content_asset.assetable.text_answer
      })
      .catch((e) => {
        this.errors = e
      })
  },
}
</script>
<style lang="sass"></style>
